import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { alternativeStartRegisterAdmin } from "../../app/actions/alternativeActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import useFormValidations from "../../app/hooks/useFormValidations";
import useModuleNewEditFields from "../../app/hooks/useModuleNewEditFields";
import { attachModuleFormScope } from "../../app/helpers/moduleFormScopeHelper";
import { attachPreDriTermOrWarn } from "../../app/helpers/preDriTermLinkHelper";
import PreDriCreateBar from "../specialist-selection/PreDriCreateBar";
import NavbarIconsModuleContext from "../generic-nav-bar/NavbarIconsModuleContext";
import FlowFichaSections from "../specialist-flow-engine/components/FlowFichaSections";
import { hydrateCatalogSelectFields } from "../../app/helpers/helperCatalogs";

const NewAlternative = () => {
  debugLogPages(':: NewAlternative');

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  /********Store*******/

  const { listFullCatalogCiius, listCatalogCiiusLevel1, listCatalogCiiusLevel2, listCatalogCiiusLevel3, listCatalogCiiusLevel4, listCatalogCiiusLevel5, listCatalogCiiusLevel6 } =
    useSelector((state) => state.catalogCiiu);

  const { listFullCatalogSections, listCatalogSectionsLevel1, listCatalogSectionsLevel2, listCatalogSectionsLevel3 } =
    useSelector((state) => state.catalogSection);

  const { listFullCatalogPhases, listCatalogPhasesLevel1, listCatalogPhasesLevel2, listCatalogPhasesLevel3, listCatalogPhasesLevel4 } =
    useSelector((state) => state.catalogPhase);

  const { listContinents, listRegions, listCountries } = useSelector((state) => state.locationCountry);

  const { validationFields, arrayListPrincipal, arrayListSecondary, visibilityFlag } = useModuleNewEditFields("alternative");

  const { listSeries, listSophistications, listMagnitudes, listSizes, listTypologies, listGeneralAdaptations, listStructuralAdaptations, listSpecificAdaptations, listProblems, listMultimedias, listPriceRanges,
    listPermissionPublish, listComplexities } = useSelector((state) => state.catalog);

  /********UseForm*******/
  const { values, errors, handleChange, handleChangeMulti, handleSubmit, handleChangeCatalogCiiu,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeLocation, setValues } = useFormValidations(
      () => AlternativeCallback(),
      {},
      validationFields
    );

  /********useState y useEffect*******/
  const [isDisabledProcessButton] = useState(false);

  useEffect(() => {

    if (values && values.catalogciius_id && listFullCatalogCiius) {
      let codigosCiius = values.catalogciiu_levels;

      let partes = codigosCiius.split(";");

      var objectCiiuFound = [];

      var currentCatalogCiiuLevelInValues = {
        1: values.catalogciiu_level1,
        2: values.catalogciiu_level2,
        3: values.catalogciiu_level3,
        4: values.catalogciiu_level4,
        5: values.catalogciiu_level5,
        6: values.catalogciiu_level6,
      };

      for (let i = 0; i < values.ciiulevel; i++) {
        objectCiiuFound[i] = getObjectByCode(partes[i], listFullCatalogCiius);

        handleChangeCatalogCiiu(objectCiiuFound[i], i + 1);

        currentCatalogCiiuLevelInValues[i + 1] = objectCiiuFound[i] && objectCiiuFound[i].id;
      }
    }

  }, [listFullCatalogCiius]);

  useEffect(() => {

    if (values && values.catalogsections_id && listFullCatalogSections) {
      let codigosSections = values.catalogsection_levels;

      let partes = codigosSections.split(";");

      var objectSectionFound = [];

      var currentCatalogSectionLevelInValues = {
        1: values.catalogsection_level1,
        2: values.catalogsection_level2,
        3: values.catalogsection_level3,

      };

      for (let i = 0; i < partes.length; i++) {
        objectSectionFound[i] = getObjectByCode(partes[i], listFullCatalogSections);

        handleChangeCatalogSection(objectSectionFound[i], i + 1);

        currentCatalogSectionLevelInValues[i + 1] = objectSectionFound[i] && objectSectionFound[i].id;
      }
    }

  }, [listFullCatalogSections]);

  useEffect(() => {

    if (values && values.catalogphases_id && listFullCatalogPhases) {
      let codigosPhases = values.catalogphase_levels;

      let partes = codigosPhases.split(";");

      var objectPhaseFound = [];

      var currentCatalogPhaseLevelInValues = {
        1: values.catalogphase_level1,
        2: values.catalogphase_level2,
        3: values.catalogphase_level3,
        4: values.catalogphase_level4,
        5: values.catalogphase_level5
      };

      for (let i = 0; i < partes.length; i++) {
        objectPhaseFound[i] = getObjectByCode(partes[i], listFullCatalogPhases);

        handleChangeCatalogPhase(objectPhaseFound[i], i + 1);

        currentCatalogPhaseLevelInValues[i + 1] = objectPhaseFound[i] && objectPhaseFound[i].id;
      }
    }

  }, [listFullCatalogPhases]);

  useEffect(() => {
    if (!values) {
      return;
    }

    hydrateCatalogSelectFields(handleChange, [
      { id: values.catalogserie_id, list: listSeries, field: "catalogserie_id" },
      { id: values.catalogsize_id, list: listSizes, field: "catalogsize_id" },
      { id: values.catalogmagnitude_id, list: listMagnitudes, field: "catalogmagnitude_id" },
      { id: values.catalogproblem_id, list: listProblems, field: "catalogproblem_id" },
      { id: values.catalogpricerange_id, list: listPriceRanges, field: "catalogpricerange_id" },
      { id: values.catalogpermissionpublish_id, list: listPermissionPublish, field: "catalogpermissionpublish_id" },
      { id: values.catalogcomplexity_id, list: listComplexities, field: "catalogcomplexity_id" }
    ]);
  }, [listSeries, listSophistications, listSizes, listTypologies, listMagnitudes, listProblems, listPriceRanges,
    listPermissionPublish, listComplexities])

  const AlternativeCallback = () => {
    debugLogPages(':: NewAlternative, AlternativeCallback, values', {values}); 

    let valuesSubmit = { ...values };

    valuesSubmit.general_adaptation = valuesSubmit.general_adaptation_string_list;
    valuesSubmit.structural_adaptation = valuesSubmit.structural_adaptation_string_list;
    valuesSubmit.specific_adaptation = valuesSubmit.specific_adaptation_string_list;
    valuesSubmit.catalogproblem_o = valuesSubmit.catalogproblem_string_list;

    valuesSubmit.deleted = false;
    valuesSubmit.is_bulkuploaded = false;

    valuesSubmit.catalogciius_i = getObjectById(valuesSubmit.catalogciius_id, listFullCatalogCiius)?.name;
    valuesSubmit.catalogsections_i = getObjectById(valuesSubmit.catalogsections_id, listFullCatalogSections)?.name;
    valuesSubmit.catalogphases_i = getObjectById(valuesSubmit.catalogphases_id, listFullCatalogPhases)?.name;

    valuesSubmit.deep_indicator = parseFloat(valuesSubmit.deep_indicator);
    valuesSubmit.protection_indicator = parseFloat(valuesSubmit.protection_indicator);
    valuesSubmit.applicability_indicator = parseFloat(valuesSubmit.applicability_indicator);
    valuesSubmit.relevance_indicator = parseFloat(valuesSubmit.relevance_indicator);
    valuesSubmit.mitigation_indicator = parseFloat(valuesSubmit.mitigation_indicator);
    valuesSubmit.adaptation_indicator = parseFloat(valuesSubmit.adaptation_indicator);
    valuesSubmit.performance_indicator = parseFloat(valuesSubmit.performance_indicator);

    debugLogPages(':: NewAlternative, AlternativeCallback, valuesSubmit', {valuesSubmit}); 

    const payload = attachPreDriTermOrWarn(attachModuleFormScope(valuesSubmit, visibilityFlag));
    if (!payload) {
      return;
    }
    dispatch(alternativeStartRegisterAdmin(payload, navigate, location.state?.returnTo || ""));

  };

  const getObjectById = (id, arraySearch) => {
    const elementFound = arraySearch.find((ser) => ser.id === id);
    return elementFound;
  };

  const getObjectByCode = (code, arraySearch) => {
    const elementFound = arraySearch.find((ser) => ser.code === code);
    return elementFound;
  };

  const getMethodData = (currentData) => {
    let comboData = [];
    let level = 0;

    if (currentData === "series") {
      comboData = listSeries;
      level = 1;
    } else if (currentData === "ciius_level1") {
      comboData = listCatalogCiiusLevel1;
      level = 1;
    } else if (currentData === "ciius_level2") {
      comboData = listCatalogCiiusLevel2;
      level = 2;
    } else if (currentData === "ciius_level3") {
      comboData = listCatalogCiiusLevel3;
      level = 3;
    } else if (currentData === "ciius_level4") {
      comboData = listCatalogCiiusLevel4;
      level = 4;
    } else if (currentData === "ciius_level5") {
      comboData = listCatalogCiiusLevel5;
      level = 5;
    } else if (currentData === "ciius_level6") {
      comboData = listCatalogCiiusLevel6;
      level = 6;
    } else if (currentData === "sections_level1") {
      comboData = listCatalogSectionsLevel1;
      level = 1;
    } else if (currentData === "sections_level2") {
      comboData = listCatalogSectionsLevel2;
      level = 2;
    } else if (currentData === "sections_level3") {
      comboData = listCatalogSectionsLevel3;
      level = 3;
    } else if (currentData === "phases_level1") {
      comboData = listCatalogPhasesLevel1;
      level = 1;
    } else if (currentData === "phases_level2") {
      comboData = listCatalogPhasesLevel2;
      level = 2;
    } else if (currentData === "phases_level3") {
      comboData = listCatalogPhasesLevel3;
      level = 3;
    } else if (currentData === "phases_level4") {
      comboData = listCatalogPhasesLevel4;
      level = 4;
    } else if (currentData === "phases_level5") {
      comboData = listCatalogPhasesLevel4;
      level = 5;
    } else if (currentData === "sophistications") {
      comboData = listSophistications;
      level = 1;
    } else if (currentData === "magnitudes") {
      comboData = listMagnitudes;
      level = 1;
    } else if (currentData === "sizes") {
      comboData = listSizes;
      level = 1;
    } else if (currentData === "typologies") {
      comboData = listTypologies;
      level = 1;
    } else if (currentData === "problems") {
      comboData = listProblems;
      level = 1;
    } else if (currentData === "multimedias") {
      comboData = listMultimedias;
      level = 1;
    } else if (currentData === "continents") {
      comboData = listContinents;
      level = 1;
    } else if (currentData === "regions") {
      comboData = listRegions;
      level = 1;
    } else if (currentData === "countries") {
      comboData = listCountries;
      level = 1;
    } else if (currentData === "prices") {
      comboData = listPriceRanges;
      level = 1;
    } else if (currentData === "permission_publish") {
      comboData = listPermissionPublish;
      level = 1;
    } else if (currentData === "complexities") {
      comboData = listComplexities;
      level = 1;
    } else if (currentData === "general_adaptation") {
      comboData = listGeneralAdaptations;
      level = 1;
    } else if (currentData === "structural_adaptation") {
      comboData = listStructuralAdaptations;
      level = 1;
    } else if (currentData === "specific_adaptation") {
      comboData = listSpecificAdaptations;
      level = 1;
    }

    return { comboData, level };
  };

  const getSelectedProblemsOriginalCatalogs = (catalogProblemsSelected, listProblems) => {
    let listCatalogProblemsDefault = [];

    catalogProblemsSelected.forEach(catalogProblem => {
      const catalogOriginal = getObjectById(catalogProblem.catalogproblem_id, listProblems);
      if (catalogOriginal) {
        listCatalogProblemsDefault.push(catalogOriginal);
      }
    })

    return listCatalogProblemsDefault;

  }

  debugLogPages(':: NewAlternative', { 'values': values });
  debugLogPages(':: NewAlternative', { 'errors': errors });


  // Definimos las claves únicas para Alternativas
  const alternativeRelations = {
    problems: "ModProblem_To_Alternative",
    multimedia: "ModuleFile_To_Alternative"
  };

  const sharedFormProps = {
    values, errors, setValues, handleChange, handleChangeLocation,
    handleChangeMulti, handleChangeCatalogPhase, handleChangeCatalogCiiu,
    handleChangeCatalogSection, getMethodData, listProblems, listMultimedias,
    getSelectedProblemsOriginalCatalogs, // Tu función helper de alternativas
    relationKeys: alternativeRelations,
    isEditMode: false
  };

  return (
    <div>
      <NavbarIconsModuleContext moduleProcess="alternative" mode="ficha" />
      <PreDriCreateBar process="alternative" title={t("alternative.page.register")} />
      <hr className="line-hr" />
      <div className="InfoBusqueda">
        <form onSubmit={handleSubmit} noValidate>
          <div className="row">
            <FlowFichaSections
              record={values}
              process="alternative"
              arrayListPrincipal={arrayListPrincipal}
              arrayListSecondary={arrayListSecondary}
              sharedFormProps={sharedFormProps}
            />
          </div>
          <div className="btnGuardar">
            <input type="submit" value={t("buttons.submit")} className="btn btn-primary" disabled={isDisabledProcessButton} />
          </div>
        </form>
      </div>
    </div>
  );
};

  

export default NewAlternative;